import { client } from "@/store/client.js";
import axios from "axios";

export const namespaced = true;

export const state = {}

export const actions = {
    getPayments() {
        return client.coreapi.get('/getpayments')
           .then(r => {
             console.log(r.data)
             return r.data;
             //this.invoices = data;
           })
     },
    getPaymentById({commit}, id) {
        return client.coreapi.get('/getpaymentbyid/' + id)
        .then(( r ) => {
            return r.data
        })
    },
    getSubscriptions({commit}, id) {
        return client.coreapi.get('/getsubscription')
        .then(( r ) => {
            return r.data
        })
    },
    cancelSubscription({commit}) {
        return client.coreapi.get('/cancelsubscription')
        .then(( r ) => {
            return r.data
        })
    },
    resumeSubscription({commit},) {
        return client.coreapi.get('/resumesubscription')
        .then(( r ) => {
            return r.data
        })
    },
    downloadInvoice({commit}, id) {
        return client.coreapi.get('/downloadinvoice/' + id.mollie_payment_id, {responseType: 'blob'})
        .then(( r ) => {
        var fileURL = window.URL.createObjectURL(new Blob([r.data], {type: 'application/pdf'}));
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(fileURL)
            return
          }
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download','Rechnung-' + id.number + '.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        setTimeout(function () {
          window.URL.revokeObjectURL(fileURL)
        }, 100)
        })
    }
}